import { ShiftEditData } from 'api/shift'
import { ShiftType } from './types'
import { getIsCaliforniaDrivingShift } from './useIsCaliforniaDrivingShift'

export function getShiftTypeForEdit(
  data: ShiftEditData,
  isCompanyW2: boolean,
  isDrivingPosition: boolean
) {
  if (data.isTryout) {
    return ShiftType.Tryout
  }

  const isCaliforniaDrivingShift = getIsCaliforniaDrivingShift({
    isDrivingPosition,
    location: data.location,
    isW2: isCompanyW2,
  })

  if (isCaliforniaDrivingShift) {
    return ShiftType.OnDemandDeliveryBlock
  }

  return ShiftType.Regular
}
